<template>
  <div id="products" class="px-4">
    <subcategory-list />
  </div>
</template>
<script>
import SubcategoryList from "@/components/subcategory_management/SubcategoryList";

export default {
  components: {
    SubcategoryList
  },
  data: () => ({}),
  computed: {}
};
</script>

<style></style>
